<div class="pagination">
    <button (click)="previousPage()" [disabled]="currentPage === 1">Previous</button>
    <span *ngIf="pages[0] !== 1" (click)="goToPage(1)">1</span>
    <span *ngIf="pages[0] > 2">...</span>
    <span *ngFor="let page of pages" (click)="goToPage(page)" [class.active]="page === currentPage">{{ page }}</span>
    <span *ngIf="pages[pages.length - 1] < totalPages - 1">...</span>
    <span *ngIf="pages[pages.length - 1] !== totalPages" (click)="goToPage(totalPages)">{{ totalPages }}</span>
    <button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
  </div>